import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import DataTable from "../../../components/DataTable/DataTable";
import AbstractBHForm from "./AbstractBHForm";
import TitleHeader from "../../../components/TitleHeader/TitleHeader";
import { Alert, Services } from "../../Service/Services";
import axios from "../../../axios";
import swal from "sweetalert";
import { AbstractBHAPI } from "../../../api";

const $ = window.$;

class AbstractBH extends Component {
  constructor(props) {
    super(props);
    this.datatable_element = React.createRef();
    this.modal = React.createRef();
  }

  onImportFile = (params) => {
    const import_url = "/importabstractbh";

    const new_params = {
      params,
      url: import_url,
    };

    Services.submitRequestWithFile(new_params)
      .then((res) => {
        this.datatable_element.current.refresh();
      })
      .catch((err) => {
        console.log("catch", err);
        swal({
          title: "Error",
          text: err.join("\n"),
          icon: "error",
          button: "OK",
        });
      });
  };

  onPrintClick = (params) => {
    const key = params.key;
    const url = axios.defaults.baseURL + "/certificate/print/BH/" + key;

    window.open(url, "_blank");
  };

  render() {
    const columns = [
      { label: "รหัสผลงาน", align: "center", name: "abstract_no" },
      { label: "ชื่อหน่วยงาน", align: "left", name: "company_name" },
      { label: "ชื่อผลงาน", align: "left", name: "name" },
      { label: "ชื่อ-สกุล", align: "left", name: "author" },
      {
        label: "ชื่อหน่วยงาน​ (ออกใบประกาศ)",
        align: "left",
        name: "company_cert",
      },
      {
        label: "เลขประจำตัวใบประกาศนียบัตร",
        align: "center",
        name: "certificate_no",
      },
    ];

    const api_url = "/admin/abstract_bh";
    const export_url = axios.defaults.baseURL + "/exportabstractbh";

    const onSaveModal = () => {
      const key = $("#key", this.modal.current).val();
      const abstract_no = $("#abstract_no", this.modal.current).val();
      const company_name = $("#company_name", this.modal.current).val();
      const name = $("#name", this.modal.current).val();
      const author = $("#author", this.modal.current).val();
      const company_cert = $("#company_cert", this.modal.current).val();
      const certificate_no = $("#certificate_no", this.modal.current).val();

      AbstractBHAPI.updateAbstractBH(key, {
        abstract_no,
        company_name,
        name,
        author,
        company_cert,
        certificate_no,
      }).then(() => {
        Alert.done("Save complete").then(() => {
          this.datatable_element.current.refresh();
          $(this.modal.current).modal("hide");
        });
      });
    };

    return (
      <BrowserRouter>
        <div>
          <TitleHeader
            program_name="BH"
            program_type="ผลงานวิชาการ"
          ></TitleHeader>
          <Route
            exact
            path={`${this.props.match.path}/`}
            component={() => (
              <DataTable
                ref={this.datatable_element}
                columns={columns}
                allow_active={false}
                allow_insert={false}
                allow_edit={false}
                url={api_url}
                allow_print={true}
                onPrintClick={this.onPrintClick}
                onImportFile={this.onImportFile}
                allow_import={true}
                export_url={export_url}
                inline_buttons={[
                  {
                    label: (
                      <>
                        <i className="fa fa-pencil"></i> แก้ไข
                      </>
                    ),
                    className: "btn-primary",
                    onClick: (key, data) => {
                      $("#key", this.modal.current).val(key);
                      $("#abstract_no", this.modal.current).val(data.value[0]);
                      $("#company_name", this.modal.current).val(data.value[1]);
                      $("#name", this.modal.current).val(data.value[2]);
                      $("#author", this.modal.current).val(data.value[3]);
                      $("#company_cert", this.modal.current).val(data.value[4]);
                      $("#certificate_no", this.modal.current).val(
                        data.value[5]
                      );

                      $(this.modal.current).modal("show");
                    },
                  },
                ]}
              ></DataTable>
            )}
          />

          <Route
            path={`${this.props.match.path}/create`}
            component={(props) => (
              <AbstractBHForm {...props} url={api_url}></AbstractBHForm>
            )}
          />
          <Route
            path={`${this.props.match.path}/:id/edit`}
            component={(props) => (
              <AbstractBHForm {...props} url={api_url}></AbstractBHForm>
            )}
          />

          <div
            className="modal fade"
            tabindex="-1"
            role="dialog"
            ref={this.modal}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header bg-info">
                  <h5 className="modal-title">แก้ไขข้อมูล BH</h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <input type="hidden" id="key" />
                  <div class="form-group">
                    <label for="abstract_no" class="col-form-label">
                      รหัสผลงาน:
                    </label>
                    <input type="text" class="form-control" id="abstract_no" />
                  </div>
                  <div class="form-group">
                    <label for="company_name" class="col-form-label">
                      ชื่อหน่วยงาน:
                    </label>
                    <input type="text" class="form-control" id="company_name" />
                  </div>
                  <div class="form-group">
                    <label for="name" class="col-form-label">
                      ชื่อผลงาน:
                    </label>
                    <input type="text" class="form-control" id="name" />
                  </div>
                  <div class="form-group">
                    <label for="author" class="col-form-label">
                      ชื่อ-สกุล เจ้าของผลงาน:
                    </label>
                    <input type="text" class="form-control" id="author" />
                  </div>
                  <div class="form-group">
                    <label for="company_cert" class="col-form-label">
                      ชื่อหน่วยงาน​ (ออกใบประกาศ):
                    </label>
                    <input type="text" class="form-control" id="company_cert" />
                  </div>
                  <div class="form-group">
                    <label for="certificate_no" class="col-form-label">
                      เลขประจำใบประกาศนียบัตร:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="certificate_no"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onSaveModal}
                  >
                    Save changes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default AbstractBH;
